import { getGenderOptions } from "../CreateEmployee/Forms/functions";

export const getFormInitialValues = (employee) => {
  const genderOptions = getGenderOptions();

  return {
    employeeInitialValues: {
      first_name: employee.first_name,
      last_name: employee.last_name,
      username: employee.user.username,
      email: employee.email,
      employee_code: employee.employee_code,
      cpf: employee.cpf,
      gender:
        genderOptions.options.find(
          (option) => option.value === employee.gender,
        ) || genderOptions.defaultGender,
      birth_date: employee.birth_date,
      work_city: employee.work_city,
      company_referal: employee.company_referal,
      phone_number: employee.user.phone_number,
      preferred_channel: employee.user.preferred_channel,
    },
  };
};
